import { SET_ACTION_TYPE_VALUE } from "../action";
import { actionType } from "./initial-store";

const initialState = actionType;

function actionTypeReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTION_TYPE_VALUE:
      return { ...state, [action.payload.name]: action.payload.value };
    default:
      return state;
  }
}

export default actionTypeReducer;
